import { createSelector } from 'reselect';

import { offerIdAsNumberSelector } from 'shared/store/custom';

import { getCoworkingOffersSelector } from '../dump/getCoworkingOffersSelector';

export const separateOfficeSelector = createSelector(
  [getCoworkingOffersSelector, offerIdAsNumberSelector],
  (offers, offerId) => {
    if (typeof offerId !== 'number') {
      return null;
    }

    return offers.find(offer => offer.id === offerId) ?? null;
  },
);
